var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50006 5.89961C4.99712 5.89961 5.40006 5.49667 5.40006 4.99961C5.40006 4.50255 4.99712 4.09961 4.50006 4.09961C4.00301 4.09961 3.60006 4.50255 3.60006 4.99961C3.60006 5.49667 4.00301 5.89961 4.50006 5.89961Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.206055 4.99963C0.779468 3.17392 2.4851 1.84961 4.50005 1.84961C6.51498 1.84961 8.22061 3.1739 8.79403 4.99959C8.22062 6.8253 6.51498 8.14961 4.50004 8.14961C2.48511 8.14961 0.779479 6.82532 0.206055 4.99963ZM6.30006 4.99961C6.30006 5.99372 5.49418 6.79961 4.50006 6.79961C3.50595 6.79961 2.70006 5.99372 2.70006 4.99961C2.70006 4.0055 3.50595 3.19961 4.50006 3.19961C5.49418 3.19961 6.30006 4.0055 6.30006 4.99961Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidEye);
export default __webpack_public_path__ + "static/media/solid-eye.402beb78b6565ba257565fe4c0ae6d58.svg";
export { ForwardRef as ReactComponent };